import React, { useState, useRef } from 'react';
import { Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import LoadingButton from '@mui/lab/LoadingButton';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import ApiHelper from 'utils/apiHelper';
import { convertDate } from 'utils/commonHelpers';

const AddScriptDialog = ({ onClose }) => {
    const today = new Date();
    const fileInput = useRef(null);
    const [scriptName, setScriptName] = useState('New Script');
    const [scriptDescription, setScriptDescription] = useState('');
    const [updatedDate, setUpdatedDate] = useState(today);
    const [file, setFile] = useState();
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = () => {
        if (!file) {
            toast.warning('Please select the script file');
            return true;
        }
        const formData = new FormData();
        formData.append('file', file);
        formData.append('file_name', file.name);
        formData.append('name', scriptName);
        formData.append('description', scriptDescription);
        formData.append('updated_date', convertDate(updatedDate));
        setLoading(true);
        ApiHelper.post(`/api/server/scripts/`, formData)
            .then(() => {
                toast.success('Successfully added');
                onClose();
                setLoading(false);
            })
            .catch((err) => {
                toast.error(`Fail! ${err.response.data.message}`);
                setLoading(false);
            });
    };

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>Add New Script</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Script Name"
                        value={scriptName}
                        onChange={(e) => setScriptName(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Script Description"
                        value={scriptDescription}
                        onChange={(e) => setScriptDescription(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="File Name"
                        value={file ? file.name : ''}
                        disabled={true}
                        // onChange={(e) => setFileName(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Updated Date"
                            value={updatedDate}
                            onChange={(newValue) => {
                                setUpdatedDate(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} />}
                        />
                    </LocalizationProvider>
                </Box>
                <Box sx={{ mt: 3, mb: 3, display: 'flex' }}>
                    <Button color="primary" variant="contained" onClick={() => fileInput.current.click()}>
                        Choose Script File
                    </Button>
                    <input type="file" accept=".ps1" ref={fileInput} style={{ display: 'none' }} onChange={handleChange} />
                    {file && <Typography sx={{ marginLeft: '15px', mt: 1 }}>{file.name}</Typography>}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <LoadingButton loading={loading} onClick={handleSubmit} color="primary" variant="contained">
                    Submit
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

AddScriptDialog.propTypes = {
    onClose: PropTypes.func
};

export default AddScriptDialog;
